import React , { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ContextProvider } from './context/contextProvider';
import { BrowserRouter } from 'react-router-dom';

//const loadingMarkup = ( <div>LOADING...</div>)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 // <Suspense fallback={loadingMarkup}>
  <React.StrictMode>
    <ContextProvider>
      <BrowserRouter>
     <App />
     </BrowserRouter>
    </ContextProvider>
  </React.StrictMode>
 // </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

